import { useEffect } from "react";

export function useInitPaddle() {
    useEffect(() => {
        const token = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;

        if (!token) {
            console.error("❌ Missing REACT_APP_PADDLE_CLIENT_TOKEN");
            return;
        }

        // Derived from the token so the two can never drift apart: a live_ token
        // in sandbox (or test_ in production) fails as an unfindable transaction.
        const environment = token.startsWith("live_") ? "production" : "sandbox";

        function initWhenReady() {
            if (!window.Paddle || !window.Paddle.Initialize) {
                return setTimeout(initWhenReady, 50);
            }

            window.Paddle.Environment.set(environment);

            window.Paddle.Initialize({
                token,

                /* The webhook only reports a failure after the fact, and says
                   nothing about what the customer saw. `checkout.payment.failed`
                   is the browser-side counterpart of transaction.payment_failed
                   and is the only place a 3-D Secure challenge that was never
                   completed leaves a trace we control. */
                eventCallback: (event) => {
                    if (event?.name === "checkout.payment.failed") {
                        console.error("Paddle payment failed", event.data);
                        return;
                    }

                    // checkout.error carries no `data`, so log the event itself.
                    if (event?.name === "checkout.error" || event?.name === "checkout.warning") {
                        console.error(`Paddle ${event.name}`, event);
                    }
                },
            });

            window.__PADDLE_READY__ = true;
        }

        initWhenReady();
    }, []);
}